module.exports = __webpack_public_path__ + "img/AufgegessenWerden.984145ca.svg";